<template>
  <div v-html="text" class="doc"></div>
</template>

<script>
export default {
  data() {
    return {
      text: `《中升GO用户服务协议》Ver1.0</br>
      更新日期：2023年8月25日</br></br>
      特别提示：</br>
      欢迎您来到中升GO服务平台！</br>
【审慎阅读】为了您更方便更安全地使用中升GO服务，您应当认真阅读并遵守《中升GO用户服务协议》（以下简称“本协议”）。请您在注册或使用第三方账号登录中升GO平台之前，仔细阅读、充分理解本协议的各个条款相关内容，特别是以加粗或下划线形式提示您特别注意的条款及内容。</br></br>      
【同意签约】当您按照注册页面提示填写注册信息、阅读并同意本协议且完成全部注册程序后或使用第三方账号登录中升GO平台，或您在本协议生效后继续使用中升GO平台服务的，即表示您已仔细阅读、充分理解并接受本协议的全部内容，并与中升GO达成一致，同意成为中升GO平台“用户”，自愿接受本协议的约束。</br></br>
      阅读本协议的过程中，如果您不同意或不理解本协议或其中任何条款，您应立即停止注册程序并停止使用中升GO平台服务。</br>

本“特别提示”内容是本协议正文的组成部分。与协议其他条款有同样约束力。</br>

1、定义</br>

1.1、中升GO平台：指包括中升GO APP端、微信小程序端、微信公众号端及未来可能出现的新的服务平台。</br>
1.2、中升GO平台服务：中升GO基于互联网，以包含中升GO平台APP端等在内的各种形态（包括未来技术发展出现的新的服务形态）向您提供的各项服务。</br>
1.3、中升GO平台规则：包括在所有中升GO平台规则频道内已经发布及后续发布的全部规则、解读、公告等内容以及各平台在论坛、帮助中心内发布的各类规则、实施细则、产品流程说明、公告等</br>
1.4、同一用户：使用同一身份认证信息或经中升GO排查认定多个中升GO账户的实际控制人为同一人的，均视为同一用户。</br>

2、协议范围</br>

2.1签约主体</br>

【平等主体】本协议由您与中升GO平台经营者共同缔结，本协议对您与中升GO平台经营者均具有合同效力。</br>

【主体信息】中升GO平台经营者是指经营中升GO平台的法律主体。本协议项下，中升GO平台经营者可能根据中升GO平台的业务调整而发生变更，变更后的中升GO平台经营者与您共同履行本协议并向您提供服务，中升GO平台经营者的变更不会影响您本协议项下的权益。中升GO平台经营者还有可能因为提供新的中升GO平台服务而新增，如您使用新增的中升GO平台服务的，视为您同意新增的中升GO平台经营者与您共同履行本协议。发生争议时，您可根据您具体使用的服务及对您权益产生影响的具体行为对象确定与您履约的主体及争议相对方。</br>

2.2中升GO用户协议</br>

即本协议，指您与中升GO经营主体订立的旨在约定您登陆、使用中升GO平台各项服务过程中，您与中升GO经营者主体之间的权利义务关系的书面合同，包括但不限于通过中升GO平台下达订单、购买商品及服务、支付货款、收取商品、参加活动等过程。您理解并同意，您通过综合平台中的任何一种服务载体注册并登录，成为中升GO用户后，即受本协议的约束。您登陆平台使用中升GO平台内任何一项服务时，本协议即规范您与相应运营者之间的权利义务关系。</br>

2.3中升GO规则</br>

中升GO规则包括中升GO已经发布或将来发布、修订的各类通知、公告、服务条款、规则、规范、规则解读、实施细则等，具体以相关页面展示内容为准。您在使用中升GO平台中的具体服务时，应特别关注相关服务条款或规则，您同意本协议或已实际使用该服务的，即表示您同意前述条款并接受条款约束。</br>

2.4 协议修订</br>

为了给你提供更好的服务，中升GO将根据业务发展变化对本协议作相应的调整，中升GO将按照相关法律法规的规定对修订内容提前进行公示，修订后的协议一经生效，将完全替代修订前的协议。您应当及时关注和了解本协议的修订情况，如果您不同意修订后的协议，请您立即停止使用中升GO平台，否则即视为您完全同意并接受修订后的协议接受约束。</br>

2.5协议范围</br>

由于社会经济与互联网行业的高速发展，现有的约定不能保证完全符合未来发展的需求，您与中升GO签署的本协议列明的条款也并不能完整罗列并覆盖您与中升GO所有权利与义务。因此中升GO平台法律声明及隐私权政策、中升GO平台规则等均为本协议的补充协议，与本协议不可分割且具有同等法律效力。如您使用中升GO平台服务，视为您同意上述补充协议。</br>

3、账户注册与使用</br>

3.1用户资格</br>

在您开始注册程序使用中升GO平台服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。</br>


3.2账户说明</br>
【账户注册】当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，您可获得中升GO平台账户并成为中升GO平台用户。</br>

【账户使用】您有权使用您设置或确认的中升GO会员名、手机号码（以下简称“账户名称”）及您设置的密码（账户名称及密码合称“账户”）登录中升GO平台。</br>

您有权使用您的中升GO账户登录中升GO平台而无需另行设置账户，但您的手机号码已在中升GO平台注销除外。</br>

由于您的中升GO账户关联您的个人信息及中升GO平台商业信息，您的中升GO账户仅限您本人使用。未经中升GO平台同意，您直接或间接授权第三方使用您中升GO账户或获取您账户项下信息的行为无效。如中升GO平台判断您中升GO账户的使用可能危及您的账户安全及/或中升GO平台信息安全的，中升GO平台可拒绝提供相应服务或终止本协议。</br>

【账户转让】由于用户账户关联用户信用信息，仅当有法律明文规定、司法裁定或经中升GO同意，并符合中升GO平台规则规定的用户账户转让流程的情况下，可进行账户的转让。您的账户一经转让，该账户项下权利义务一并转移。除此外情况，您的账户不得以任何方式转让，否则中升GO平台有权追究您的违约责任，且由此产生的一切责任均由您承担。</br>

【实名认证】为使您更好地使用中升GO平台的各项服务，保障您的账户安全，中升GO可以要求您按我公司要求及我国法律规定完成实名认证。</br>

【不活跃账户回收可能】未来如您的账户同时符合以下条件，则中升GO可能会回收您的账户，您的账户将不能再登录任一中升GO平台，相应服务同时终止：</br>

（1）未绑定通过实名认证的手机号账户；</br>
（2）连续六个月未用于登录任一中升GO平台；</br>
（3）不存在未到期的有效业务。</br>

3.3注册信息管理</br>

3.3.1真实合法</br>

【信息真实】在使用中升GO平台服务时，您应当按中升GO平台页面的提示准确完整地提供您的信息（包括您的姓名、联系电话、联系地址等），以便中升GO或其他用户与您联系。您了解并同意，您有义务保持您提供信息的真实性及有效性。</br>

【会员名的合法性】您设置的中升GO会员名不得违反国家法律法规及中升GO网规则关于会员名的管理规定，否则中升GO可回收您的中升GO会员名。中升GO会员名的回收不影响您以手机号码等形式登录中升GO平台并使用中升GO平台服务。</br>

3.3.2更新维护</br>

在法律有明确规定要求中升GO作为平台服务提供者必须对部分用户（如平台卖家等）的信息进行核实的情况下，中升GO将依法不定时对您的信息进行检查核实，您应当配合提供最新、真实、完整、有效的信息。</br>

如中升GO按您最后一次提供的信息与您联系未果、您未按中升GO的要求及时提供信息、您提供的信息存在明显不实或行政司法机关核实您提供的信息无效的，您将承担因此对您自身、他人及中升GO造成的全部损失与不利后果。中升GO可向您发出询问或要求整改的通知，并要求您进行重新认证，直至中止、终止对您提供部分或全部中升GO平台服务，中升GO对此不承担责任。</br>

3.4账户安全规范</br>

【账户安全保管义务】您的账户为您自行设置并由您保管，中升GO任何时候均不会主动要求您提供您的账户密码。因此，建议您务必保管好您的账户，并确保您在每个上网时段结束时退出登录并以正确步骤离开中升GO平台。</br>

账户因您主动泄露、出借账户信息或因您遭受他人攻击、诈骗等行为导致的损失及后果，中升GO不承担相关责任，您应通过司法、行政等救济途径向侵权行为人追偿。</br>

【账户行为责任自负】除中升GO存在过错的情况外，您应对您账户项下的所有行为结果（包括但不限于在线签署各类协议、发布信息、购买商品及服务及披露信息等）负责。</br>

【日常维护须知】如发现任何未经授权使用您账户登录中升GO平台或其他可能导致您账户遭窃、遗失的情况，建议您立即通知中升GO，并授权中升GO将该信息同步给中升GO公司及中升GO平台。您理解中升GO对您的任何请求采取行动均需要合理时间，且中升GO应您请求而采取的行动可能无法避免或阻止侵害后果的形成或扩大，除中升GO存在法定过错外，中升GO不承担责任。</br>

4、交易行为及活动规范</br>

【服务概况】您有权在中升GO平台上享受积分兑换、充值、商品及/或服务的挑选、商品及/或服务的购买与评价、交易争议处理等服务。中升GO提供的服务内容众多，具体您可登录中升GO平台浏览。</br>

4.1订单确认</br>

当您在中升GO服务平台购买商品或服务时，请您务必仔细确认所购买商品的描述，包括但不限于名称、价格、数量、型号、规格、尺寸、大小、商品瑕疵、购买及/或使用者限制等重要事项信息。并在下单时核实您的联系地址、电话机收货人等信息。如果您填写的收货人非您本人，则该收货人的行为和意思表示产生的法律后果均由您承担。</br>

4.2 交易秩序</br>

您的购买行为应基于您的真实消费需求且不得实施恶意购买、恶意维权、虚假交易等扰乱市场及中升GO平台正常交易秩序的行为。</br>

4.3 合同成立及生效</br>

您通过中升GO平台下达订单后，仅表示系统收到您下达的订单，即邀约。只有支付对应价款后您与销售方之间的买卖合同才成立，从此可开始双方收到买卖合同约束。</br>

4.4商品及/或服务的购买</br>

【商品及/或服务的购买】当您在中升GO平台购买商品及/或服务时，请您务必仔细确认所购商品的品名、价格、数量、型号、规格、尺寸或服务的时间、内容、限制性要求等重要事项，并在下单时核实您的联系地址、电话、收货人等信息。如您填写的收货人非您本人，则该收货人的行为和意思表示产生的法律后果均由您承担。</br>

您的购买行为应当基于真实的消费需求，不得存在对商品及/或服务实施恶意购买、恶意维权等扰乱中升GO平台正常交易秩序的行为。基于维护中升GO平台交易秩序及交易安全的需要，中升GO发现上述情形时可主动执行关闭相关交易订单等操作。</br>

4.5交易争议处理</br>

【交易争议处理途径】您在中升GO平台交易过程中与其他用户发生争议的，您或其他用户中任何一方均有权选择以下途径解决：</br>

（1）与争议相对方自主协商；</br>

（2）使用中升GO平台提供的争议调处服务；</br>

（3）请求消费者协会或者其他依法成立的调解组织调解；</br>

（4）向有关行政部门投诉；</br>

（5）根据与争议相对方达成的仲裁协议（如有）提请仲裁机构仲裁；</br>

（6）向人民法院提起诉讼。</br>


4.6费用</br>

中升GO平台向您提供的服务已付出了大量的成本，除中升GO平台明示的收费业务外，中升GO向您提供的服务目前是免费的。如未来中升GO向您收取合理费用，中升GO会采取合理途径并以足够合理的期限提前以本协议第八条约定的方式通知您，确保您有充分选择的权利。</br>

4.7责任限制</br>

【不可抗力及第三方原因】中升GO依照法律规定履行基础保障义务，但对于下述原因导致的合同履行障碍、履行瑕疵、履行延后或履行内容变更等情形，中升GO并不承担相应的违约责任：</br>

（1）因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；</br>

（2）因电力供应故障、通讯网络故障等公共服务因素或第三人因素；</br>

（3）在中升GO已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。</br>

【海量信息】中升GO仅向您提供中升GO平台服务，您了解中升GO平台上的信息系用户自行发布，且可能存在风险和瑕疵。鉴于中升GO平台具备存在海量信息及信息网络环境下信息与实物相分离的特点，中升GO无法逐一审查商品及/或服务的信息，无法逐一审查交易所涉及的商品及/或服务的质量、安全以及合法性、真实性、准确性，对此您应谨慎判断。</br>

5、用户信息的保护及授权</br>

5.1个人信息的保护</br>

中升GO非常重视用户个人信息（即能够独立或与其他信息结合后识别用户身份的信息）的保护，在您使用中升GO提供的服务时，您同意中升GO按照在中升GO平台上公布的隐私权政策收集、存储、使用、披露和保护您的个人信息。中升GO希望通过隐私权政策向您清楚地介绍中升GO对您个人信息的处理方式，因此中升GO建议您完整地阅读隐私权政策（点击此处或点击中升GO平台首页底部链接），以帮助您更好地保护您的隐私权。</br>

5.2非个人信息的保证与授权</br>

【信息的发布】您声明并保证，您对您所发布的信息拥有相应、合法的权利。否则，中升GO可对您发布的信息依法或依本协议进行删除或屏蔽。</br>

【禁止性信息】您应当确保您所发布的信息不包含以下内容：</br>

（1）违反国家法律法规禁止性规定的；</br>

（2）政治宣传、封建迷信、淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</br>

（3）欺诈、虚假、不准确或存在误导性的；</br>

（4）侵犯他人知识产权或涉及第三方商业秘密及其他专有权利的；</br>

（5）侮辱、诽谤、恐吓、涉及他人隐私等侵害他人合法权益的；</br>

（6）存在可能破坏、篡改、删除、影响中升GO平台任何系统正常运行或未经授权秘密获取中升GO平台及其他用户的数据、个人资料的病毒、木马、爬虫等恶意软件、程序代码的；</br>

（7）其他违背社会公共利益或公共道德或依据相关中升GO平台协议、规则的规定不适合在中升GO平台上发布的。</br>

【授权使用】对于您提供、发布及在使用中升GO平台服务中形成的除个人信息外的文字、图片、视频、音频等非个人信息，在法律规定的保护期限内您免费授予中升GO及其关联公司获得全球范围内的排他的许可使用权利，及再授权给其他第三方使用并可以自身名义对第三方侵权行为取证及提起诉讼的权利。您同意中升GO及其关联公司存储、使用、复制、修订、编辑、发布、展示、翻译、分发您的非个人信息或制作其派生作品，并以已知或日后开发的形式、媒体或技术将上述信息纳入其它作品内。</br>

为方便您使用中升GO平台相关服务，您授权中升GO将您在账户注册和使用中升GO平台服务过程中提供、形成的信息传递给中升GO平台及其他相关服务提供者，或从中升GO平台及其他相关服务提供者获取您在注册、使用相关服务期间提供、形成的信息。</br>

6、用户的违约及处理</br>

6.1违约认定</br>

发生如下情形之一的，视为您违约：</br>

（1）使用中升GO平台服务时违反有关法律法规规定的；</br>

（2）违反本协议或本协议补充协议约定的。</br>

为适应电子商务发展和满足海量用户对高效优质服务的需求，您理解并同意，中升GO可在中升GO平台规则中约定违约认定的程序和标准。如：中升GO可依据您及您的用户数据与海量用户数据的关系来认定您是否构成违约；您有义务对您的数据异常现象进行充分举证和合理解释，否则将被认定为违约。</br>

6.2违约处理措施</br>

【信息处理】您在中升GO平台上发布的信息构成违约的，中升GO可根据相应规则立即对相应信息进行删除、屏蔽处理或对您的订单及/或商品进行下架、监管。</br>

【行为限制】您在中升GO平台上实施的行为，或虽未在中升GO平台上实施但对中升GO平台及其用户产生影响的行为构成违约的，中升GO可依据相应规则对您执行账户扣分、限制参加营销活动、中止向您提供部分或全部服务、划扣违约金等处理措施。如您的行为构成根本违约的，中升GO可查封您的账户，终止向您提供服务。</br>

【处理结果公示】中升GO可将对您上述违约行为处理措施信息以及其他经国家行政或司法机关生效法律文书确认的违法信息在中升GO平台上予以公示。</br>

6.3赔偿责任</br>

如您的行为使中升GO及/或其关联公司遭受损失（包括自身的直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失），您应赔偿中升GO及/或其关联公司的上述全部损失。</br>

如您的行为使中升GO及/或其关联公司遭受第三人主张权利，中升GO及/或其关联公司可在对第三人承担金钱给付等义务后就全部损失向您追偿。</br>

如因您的行为使得第三人遭受损失或您怠于履行调处决定、中升GO及/或其关联公司出于社会公共利益保护或消费者权益保护目的，可指示中升GO账户自您的积分账户中划扣相应权益或款项进行支付。如您的积分余额或现金余额不足以支付相应款项的，您同意委托中升GO使用自有资金代您支付上述款项，您应当返还该部分费用并赔偿因此造成中升GO的全部损失。</br>

您同意中升GO指示中升GO账户自您的积分账户中划扣相应款项支付上述赔偿款项。如您积分账户中的款项不足以支付上述赔偿款项的，中升GO及/或关联公司可直接抵减您在中升GO及/或其关联公司其它协议项下的权益，并可继续追偿。</br>

7、协议的变更</br>

中升GO可根据国家法律法规变化及维护交易秩序、保护消费者权益需要，不时修改本协议、补充协议，变更后的协议、补充协议（下称“变更事项”）将通过本协议第8条约定的方式通知您。</br>

如您不同意变更事项，您有权于变更事项确定的生效日前联系中升GO反馈意见。如反馈意见得以采纳，中升GO将酌情调整变更事项。</br>

如您对已生效的变更事项仍不同意的，您应当于变更事项确定的生效之日起停止使用中升GO平台服务，变更事项对您不产生效力；如您在变更事项生效后仍继续使用中升GO平台服务，则视为您同意已生效的变更事项。</br>

8、通知</br>

8.1有效联系方式</br>

您在注册成为中升GO平台用户，并接受中升GO平台服务时，您应该向中升GO提供真实有效的联系方式（包括您的联系电话、联系地址等），对于联系方式发生变更的，您有义务及时更新有关信息，并保持可被联系的状态。</br>

您在注册中升GO平台用户时生成的用于登陆中升GO平台接收站内信和系统消息的会员账号（包括子账号），也作为您的有效联系方式。</br>

中升GO将通过您的上述联系方式的其中之一或其中若干向您送达各类通知，而此类通知的内容可能对您的权利义务产生重大的有利或不利影响，请您务必及时关注。</br>

您有权通过您注册时填写的手机号码或者电子邮箱获取您感兴趣的商品广告信息、促销优惠等商业性信息；您如果不愿意接收此类信息，您有权通过中升GO提供的相应的退订功能进行退订。</br>

8.2通知的送达</br>

中升GO通过上述联系方式向您发出通知，其中以电子的方式发出的书面通知，包括但不限于在中升GO平台公告，向您提供的联系电话发送手机短信，向您提供的电子邮件地址发送电子邮件，向您的账号推送信息、系统消息以及站内信信息，在发送成功后即视为送达；以纸质载体发出的书面通知，按照提供联系地址交邮后的第五个自然日即视为送达。</br>

对于在中升GO平台上因交易活动引起的任何纠纷，您同意司法机关（包括但不限于人民法院）可以通过手机短信、电子邮件等现代通讯方式或邮寄方式向您送达法律文书（包括但不限于诉讼文书）。您指定接收法律文书的手机号码等联系方式，为您在中升GO平台注册、更新时提供的手机号码等联系方式，司法机关向上述联系方式发出法律文书即视为送达。您指定的邮寄地址为您的法定联系地址或您提供的有效联系地址。</br>

您同意司法机关可采取以上一种或多种送达方式向您达法律文书，司法机关采取多种方式向您送达法律文书，送达时间以上述送达方式中最先送达的为准。</br>

您同意上述送达方式适用于各个司法程序阶段。如进入诉讼程序的，包括但不限于一审、二审、再审、执行以及督促程序等。</br>

您应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由您自行承担由此可能产生的法律后果。</br>

9、协议的终止</br>

9.1终止的情形</br>

【用户发起的终止】您有权通过以下任一方式终止本协议：</br>

（1）在满足中升GO公示的账户注销条件时您通过网站自助服务注销您的账户的；</br>

（2）变更事项生效前您停止使用并明示不愿接受变更事项的；</br>

（3）您明示不愿继续使用中升GO平台服务，且符合中升GO网终止条件的。</br>

【中升GO发起的终止】出现以下情况时，中升GO可以本协议第八条的所列的方式通知您终止本协议：</br>

（1）您违反本协议约定，中升GO依据违约条款终止本协议的；</br>

（2）您盗用他人账户、发布违禁信息、骗取他人财物、售假、扰乱市场秩序、采取不正当手段谋利等行为，中升GO依据中升GO平台规则对您的账户予以查封的；</br>

（3）除上述情形外，因您多次违反中升GO平台规则相关规定且情节严重，中升GO依据中升GO平台规则对您的账户予以查封的；</br>

（4）您的账户被中升GO依据本协议回收的；</br>

（5）您在中升GO平台有欺诈、发布或销售假冒伪劣/侵权商品、侵犯他人合法权益或其他严重违法违约行为的；</br>

（6）其它应当终止服务的情况。</br>

9.2协议终止后的处理</br>

【用户信息披露】本协议终止后，除法律有明确规定外，中升GO无义务向您或您指定的第三方披露您账户中的任何信息。</br>

【中升GO权利】本协议终止后，中升GO仍享有下列权利：</br>

（1）继续保存您留存于中升GO平台的本协议第五条所列的各类信息；</br>

（2）对于您过往的违约行为，中升GO仍可依据本协议向您追究违约责任。</br>

【交易处理】本协议终止后，对于您在本协议存续期间产生的交易订单，中升GO可通知交易相对方并根据交易相对方的意愿决定是否关闭该等交易订单；如交易相对方要求继续履行的，则您应当就该等交易订单继续履行本协议及交易订单的约定，并承担因此产生的任何损失或增加的任何费用。</br>

  10、法律适用、管辖与其他</br>

【法律适用】本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律；如法律无相关规定的，参照商业惯例及/或行业惯例。</br>


【可分性】本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。</br>

`,
    };
  },
  components: {},
  mounted() {
    document.title = "用户协议";
    // this.getActivityContent();
  },
  methods: {},
};
</script>

<style>
.doc{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    font-size: 0.24rem;
    padding: 0.2rem 0.12rem;
}
</style>